// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"cartItemTable_cart-items__6WDnt","title":"cartItemTable_title__otbSJ","header":"cartItemTable_header__CPvMs","image":"cartItemTable_image__bQDij"};